import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import './SupplierDataChangeTranslate';
import paths from '../../_helpers/paths';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { signNotify, supplierDataChangeModule } from './SupplierDataChangeDucks';

function SupplierNotifyForm() {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const loading = useSelector(state => state[supplierDataChangeModule].loading);

  const [designCapacity, setDesignCapacity] = useState('');
  const [legalAddress, setLegalAddress] = useState('');
  const [touched, setTouched] = useState({ designCapacity: false, legalAddress: false });

  const errors = {
    designCapacity: !String(designCapacity).trim()
      ? t('supplierDataChange_requiredField')
      : Number(designCapacity) <= 0
      ? t('supplierDataChange_designCapacityInvalid')
      : '',
    legalAddress: !legalAddress.trim() ? t('supplierDataChange_requiredField') : ''
  };

  const isFormValid = !errors.designCapacity && !errors.legalAddress;

  const handleSign = () => {
    setTouched({ designCapacity: true, legalAddress: true });
    if (!isFormValid) return;
    dispatch(signNotify({ serviceProviderId: id, designCapacity, legalAddress }));
  };

  const breadCrumbItems = [
    { name: t('home_subtitle'), href: paths.homePage },
    { name: t('supplierDataChange_title') }
  ];

  return (
    <div className="mb3 mt3" style={{ width: '100%' }}>
      <BreadCrumbs items={breadCrumbItems} />
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <Grid container spacing={3} alignItems="center" className="mt2">
          <Grid item xs={12} sm={5}>
            <Typography>{t('supplierDataChange_designCapacity')}</Typography>
          </Grid>
          <Grid item xs={12} sm={7}>
            <TextField
              fullWidth
              type="number"
              value={designCapacity}
              onChange={e => setDesignCapacity(e.target.value)}
              onBlur={() => setTouched(prev => ({ ...prev, designCapacity: true }))}
              error={touched.designCapacity && Boolean(errors.designCapacity)}
              helperText={touched.designCapacity ? errors.designCapacity : ''}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <Typography>{t('supplierDataChange_legalAddress')}</Typography>
          </Grid>
          <Grid item xs={12} sm={7}>
            <TextField
              fullWidth
              value={legalAddress}
              onChange={e => setLegalAddress(e.target.value)}
              onBlur={() => setTouched(prev => ({ ...prev, legalAddress: true }))}
              error={touched.legalAddress && Boolean(errors.legalAddress)}
              helperText={touched.legalAddress ? errors.legalAddress : ''}
            />
          </Grid>
        </Grid>
        <div className="mt3" style={{ textAlign: 'center' }}>
          <Button
            variant="contained"
            color="secondary"
            disabled={loading || !isFormValid}
            onClick={handleSign}
          >
            {t('supplierDataChange_sign')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SupplierNotifyForm;
